import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React, { useRef, useEffect, useState } from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';
import i18n from 'i18next';
import cx from 'classnames';
import { useSelector, useDispatch } from 'react-redux';
import CheckboxGroup from '../ui/checkbox-group';
import ModalDialog from '../ui/modal-dialog';
import DropDown from '../ui/react-ui/dropdown';
import Textarea from '../ui/textarea';
import Form from '../ui/form';
import Input from '../ui/input';
import MultipleSelector from '../ui/multiple-selector';
import Checkbox from '../ui/react-ui/checkbox';
import Progress from '../ui/react-ui/progress.jsx';
import Validator from '../../utils/validator';
import { createUserAPI, editUserAPI } from '../../api/userAPI';
import { clearDialogInfo } from '../../redux/user-management';
import { setTerminalsList, setLogisticsList } from '../../redux/app';
var t = i18n.getFixedT(null, 'user-management');
var gt = i18n.getFixedT(null, 'app');
var et = i18n.getFixedT(null, 'errors');
var initUserData = {
  id: null,
  accountGroupId: '',
  accountGroupName: null,
  username: '',
  password: '',
  repassword: '',
  name: '',
  unit: '',
  employeeNo: '',
  mobilePhone: '',
  email: '',
  isEnabled: false,
  logistics: [],
  terminals: [],
  lastLoginDate: null,
  createdAt: null,
  modifiedAt: null,
  loginFailedTimes: null,
  isBindAllLogistics: false
};
var UserEdit = /*#__PURE__*/React.memo(function (props) {
  // redux
  var _useSelector = useSelector(function (state) {
    return state.toJS();
  }),
      _useSelector$envCfg = _useSelector.envCfg,
      contextRoot = _useSelector$envCfg.contextRoot,
      systemMinPasswordLength = _useSelector$envCfg.systemMinPasswordLength,
      _useSelector$app = _useSelector.app,
      allTerminalsList = _useSelector$app.allTerminalsList,
      allLogisticsList = _useSelector$app.allLogisticsList,
      _useSelector$userMana = _useSelector.userManagement,
      _useSelector$userMana2 = _useSelector$userMana.dialogInfo,
      mode = _useSelector$userMana2.mode,
      data = _useSelector$userMana2.data,
      allRoleRightList = _useSelector$userMana.allRoleRightList,
      username = _useSelector.sessionObj.username;

  var dispatch = useDispatch();
  var id = props.id,
      onClose = props.onClose;

  var _useState = useState(initUserData),
      _useState2 = _slicedToArray(_useState, 2),
      userData = _useState2[0],
      setUserData = _useState2[1]; // const [ selectedAllLogistics, setSelectedAllLogistics ] = useState(false)


  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      selectedAllTerminals = _useState4[0],
      setSelectedAllTerminals = _useState4[1];

  var _useState5 = useState(),
      _useState6 = _slicedToArray(_useState5, 2),
      error = _useState6[0],
      setError = _useState6[1];

  var form_ref = useRef(null);

  var handleClose = function handleClose() {
    dispatch(clearDialogInfo());
    setUserData(initUserData);
    setError(null);
    setSelectedAllTerminals(false); // setSelectedAllLogistics(false)
  };

  var handleDataChange = function handleDataChange(data) {
    setUserData(data);
  };

  var handleLogisticsChange = function handleLogisticsChange(dataList) {
    var newUserData = _.cloneDeep(userData);

    var logisticsList = _.map(dataList, function (el) {
      return _objectSpread({
        id: el.value
      }, el);
    });

    _.set(newUserData, 'logistics', logisticsList);

    setUserData(newUserData);
  };

  var handleTerminalsChange = function handleTerminalsChange(dataList) {
    var newUserData = _.cloneDeep(userData);

    var terminalsList = _.map(dataList, function (el) {
      return _objectSpread({
        id: el.value
      }, el);
    });

    _.set(newUserData, 'terminals', terminalsList);

    setUserData(newUserData);
  };

  var handleSelectedAccount = function handleSelectedAccount(value) {
    var newUserData = _.cloneDeep(userData);

    _.set(newUserData, 'accountGroupId', value);

    setUserData(newUserData);
  };

  var handleSelectedAllTerminals = function handleSelectedAllTerminals(value) {
    setSelectedAllTerminals(value);

    if (!value) {
      handleTerminalsChange([]);
    }
  };

  var handleSelectedAllLogistics = function handleSelectedAllLogistics(value) {
    var newUserData = _.cloneDeep(userData);

    _.set(newUserData, 'isBindAllLogistics', value);

    if (!value) _.set(newUserData, 'logistics', []);
    setUserData(newUserData);
  };

  var handleConfirm = function handleConfirm() {
    // validate
    var requiredField = ['username', 'name', 'unit', 'mobilePhone', 'email'];

    if (mode.indexOf('edit') >= 0) {
      requiredField.push('password');
      requiredField.push('repassword');

      if (userData.password != userData.repassword) {
        return setError(t('txt-password-not-match'));
      }
    }

    var fillOutRequired = Validator(requiredField, userData);
    if (fillOutRequired.length > 0) return setError(et('txt-fill-out-required'));
    if (userData.userName == userData.password) return setError(t('txt-password-equals-user-name'));
    if (_.isEmpty(userData.accountGroupId)) return setError(t('txt-account-group-id'));

    var submitData = _.cloneDeep(userData);

    _.unset(submitData, 'repassword');

    if (selectedAllTerminals) {
      var allList = _.map(allTerminalsList, function (el) {
        return _objectSpread({
          id: el.value
        }, el);
      });

      _.set(submitData, 'terminals', allList);
    } // if(selectedAllLogistics) {
    //     let allList = _.map(logisticsList, el => ({id: el.value, ...el}))
    //     _.set(submitData, 'logistics', allList)
    // }


    Progress.startSpin();

    if (mode.indexOf('create') >= 0) {
      createUserAPI(contextRoot, true, submitData).then(function (result) {
        setUserData(initUserData);
        setError(null);
        onClose();
      }).catch(function (error) {
        setError(error.message);
        Progress.done();
      });
    } else {
      _.unset(submitData, 'sequence');

      _.set(submitData, 'accountGroupName', null);

      editUserAPI(contextRoot, true, submitData).then(function (result) {
        setUserData(initUserData);
        setError(null);

        if (username === submitData.username) {
          var terminalList = submitData.terminals.length === 0 ? [] : _.map(submitData.terminals, function (el) {
            return {
              value: el.id,
              text: el.text,
              zoneId: el.zoneId
            };
          });
          dispatch(setTerminalsList(terminalList));
          var logisticsList = submitData.logistics.length === 0 ? [] : _.map(submitData.logistics, function (el) {
            return {
              value: _.trim(el.id),
              text: el.text
            };
          });
          dispatch(setLogisticsList(logisticsList));
        }

        onClose();
      }).catch(function (error) {
        Progress.done();
        setError(error.message);
      });
    }
  };

  useEffect(function () {
    if (mode.indexOf('user.edit') >= 0) {
      var formData = _.cloneDeep(data);

      _.set(formData, 'repassword', data.password);

      setUserData(formData);
      if (allTerminalsList.length === formData.terminals.length) setSelectedAllTerminals(true); // if(logisticsList.length === formData.logistics.length)
      //     setSelectedAllLogistics(true)
    }

    if (mode.indexOf('user.create') >= 0) setUserData(initUserData);
  }, [mode]);
  if (mode.indexOf('user') < 0 || mode.indexOf('edit') > 0 && _.isEmpty(userData.id)) return null;

  var selectorList = _.map(allRoleRightList, function (el) {
    return {
      value: el.id,
      text: el.name
    };
  });

  var pattern = new RegExp("^((?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%&/=?_.,:;\\-])).{".concat(systemMinPasswordLength, ",}|\\{\\(enc\\)\\}.*$")); // fields form

  var fields = {}; // account

  _.set(fields, 'username', {
    label: t('lbl-account'),
    editor: Input,
    props: {
      readOnly: !!data.id,
      required: true,
      validate: {
        t: function t(code) {
          return et("txt-".concat(code));
        }
      }
    }
  });

  if (mode.indexOf('edit') >= 0) {
    _.set(fields, 'password', {
      label: t('lbl-password'),
      editor: Input,
      props: {
        type: 'password',
        required: true,
        validate: {
          pattern: pattern,
          t: function t(code) {
            return et("txt-".concat(code));
          }
        }
      }
    });

    _.set(fields, 'repassword', {
      label: t('lbl-re-password'),
      editor: Input,
      props: {
        type: 'password',
        required: true,
        validate: {
          t: function t(code) {
            return et("txt-".concat(code));
          }
        }
      }
    });
  }

  _.set(fields, 'employeeNo', {
    label: t('lbl-employeeNo'),
    editor: Input,
    props: {// required: true,
      // validate: {
      //     t: code => {
      //         return et(`txt-${code}`)
      //     }
      // }
    }
  });

  _.set(fields, 'name', {
    label: t('lbl-name'),
    editor: Input,
    props: {
      required: true,
      validate: {
        t: function t(code) {
          return et("txt-".concat(code));
        }
      }
    }
  });

  _.set(fields, 'mobilePhone', {
    label: t('lbl-contact-phone'),
    editor: Input,
    props: {
      required: true // validate: {
      //     pattern: /^\d+$/,
      //     t: code => {
      //         return et(`txt-${code}`)
      //     }
      // }

    }
  });

  _.set(fields, 'email', {
    label: t('dlg-eMail'),
    editor: Input,
    props: {
      required: true,
      validate: {
        pattern: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
        t: function t(code) {
          return et("txt-".concat(code));
        }
      }
    }
  });

  _.set(fields, 'unit', {
    label: t('lbl-department'),
    editor: Input,
    props: {
      required: true,
      validate: {
        t: function t(code) {
          return et("txt-".concat(code));
        }
      }
    }
  });

  _.set(fields, 'accountGroupId', {
    label: t('lbl-role-rights'),
    formatter: function formatter(val, row) {
      if (row.username === 'admin' && mode.indexOf('edit') >= 0) return row.accountGroupName;
      return /*#__PURE__*/React.createElement(DropDown, {
        width: "157px",
        defaultText: t('dlg-select'),
        list: selectorList,
        value: val,
        onChange: handleSelectedAccount
      });
    }
  });

  if (mode.indexOf('edit') >= 0) {
    _.set(fields, 'createdByName', {
      label: t('lbl-created-by-name'),
      formatter: function formatter(val, row) {
        return /*#__PURE__*/React.createElement("div", null, val);
      }
    });

    _.set(fields, 'createdAt', {
      label: t('lbl-created-at'),
      formatter: function formatter(val, roww) {
        return /*#__PURE__*/React.createElement("div", null, val);
      }
    });
  }

  if (userData.username !== 'admin' || mode.indexOf('create') >= 0) {
    _.set(fields, 'terminals', {
      label: t('lbl-terminal'),
      editor: null,
      formatter: function formatter(val, row) {
        var values = selectedAllTerminals ? [] : _.map(val, function (el) {
          return {
            value: el.id ? el.id : el.value,
            text: el.name ? el.name : el.text
          };
        });
        return /*#__PURE__*/React.createElement(MultipleSelector, {
          id: "ms-terminals",
          width: '430px',
          options: allTerminalsList,
          onChange: handleTerminalsChange,
          value: values,
          disabled: selectedAllTerminals
        });
      }
    });

    _.set(fields, 'selected-all-terminal', {
      label: '',
      formatter: function formatter(val, row) {
        return /*#__PURE__*/React.createElement("div", {
          className: "selectedAll"
        }, /*#__PURE__*/React.createElement(Checkbox, {
          id: "selectedAll-terminals",
          onChange: handleSelectedAllTerminals,
          checked: selectedAllTerminals
        }), /*#__PURE__*/React.createElement("label", {
          htmlFor: "selectedAll-terminals"
        }, t('lbl-selected-all-terminals')));
      }
    });

    _.set(fields, 'logistics', {
      label: t('lbl-logistics'),
      editor: null,
      formatter: function formatter(val, row) {
        var values = row.isBindAllLogistics ? [] : _.map(val, function (el) {
          return {
            value: el.id ? el.id : el.value,
            text: el.name ? el.name : el.text
          };
        });
        return /*#__PURE__*/React.createElement(MultipleSelector, {
          id: 'ms-logistics',
          width: '430px',
          options: allLogisticsList,
          onChange: handleLogisticsChange,
          value: values,
          disabled: row.isBindAllLogistics
        });
      }
    });

    _.set(fields, 'isBindAllLogistics', {
      label: '',
      formatter: function formatter(val, row) {
        return /*#__PURE__*/React.createElement("div", {
          className: "selectedAll"
        }, /*#__PURE__*/React.createElement(Checkbox, {
          id: "selectedAll-logistics",
          onChange: handleSelectedAllLogistics,
          checked: val
        }), /*#__PURE__*/React.createElement("label", {
          htmlFor: "selectedAll-logistics"
        }, t('lbl-selected-all-logistics')));
      }
    });
  } // dailog action


  var actions = {};

  _.set(actions, 'cancel', {
    text: gt('global.lbl-answer-cancel'),
    handler: handleClose
  });

  _.set(actions, 'confirm', {
    text: gt('global.lbl-answer-ok'),
    className: 'button-success',
    // disabled: !formValid,
    handler: handleConfirm
  });

  return /*#__PURE__*/React.createElement(ModalDialog, {
    id: id,
    title: mode.indexOf('create') >= 0 ? t('dlg-create-user-account') : t('dlg-edit-user-account'),
    global: true,
    info: error,
    infoClassName: cx({
      'c-error': error
    }),
    actions: actions,
    closeAction: "cancel"
  }, /*#__PURE__*/React.createElement(Form, {
    id: "".concat(id, "-form-left"),
    ref: form_ref,
    className: "pure-form-aligned",
    fieldClassName: "pure-control-group",
    fields: fields,
    onChange: handleDataChange,
    value: userData
  }), /*#__PURE__*/React.createElement("div", {
    className: "g-user-edit-content-footer"
  }, t('txt-password-pattern', {
    length: systemMinPasswordLength
  })));
});
UserEdit.defaultProps = {
  id: 'g-user-edit'
};
UserEdit.propTypes = {
  id: PropTypes.string
};
export default UserEdit;